export default class Semaphore {
    private queue: (() => void)[] = [];
    private count: number;

    constructor(count: number) {
        this.count = count;
    }

    async acquire() {
        if (this.count > 0) {
            this.count--;
            return;
        }

        await new Promise<void>(resolve => this.queue.push(resolve));
    }

    release() {
        this.count++;
        const next = this.queue.shift();
        if (next) {
            this.count--;
            next();
        }
    }

    async use<T>(fn: () => Promise<T>): Promise<T> {
        await this.acquire();
        try {
            return await fn();
        } finally {
            this.release();
        }
    }
}
